"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = exports.getCurrency = exports.getMarket = void 0;

var _intlFormatter = require("@godaddy/intl-formatter");

var _util = require("@ux/util");

var _constants = require("../utils/constants");

var getMarket = function getMarket() {
  return _util.cookie.get(_constants.MarketConstants.COOKIE_KEY) || _constants.MarketConstants.DEFAULT_MARKET_KEY;
};

exports.getMarket = getMarket;

var getCurrency = function getCurrency() {
  return _util.cookie.get(_constants.CurrencyConstants.COOKIE_KEY) || _constants.CurrencyConstants.DEFAULT_CURRENCY_KEY;
};

exports.getCurrency = getCurrency;
var gdCurrency = new _intlFormatter.Currency();

var formatPrice = function formatPrice(market, currency, microunits) {
  return gdCurrency.formatMicrounits(microunits, market, currency);
};

exports.formatPrice = formatPrice;